var ArrayUtils;
((ArrayUtils2) => {
  ArrayUtils2.split = (data, length) => {
    const result = [];
    for (let i = 0; i < data.length; i += length) {
      result.push(data.slice(i, i + length));
    }
    return result;
  };
  ArrayUtils2.create2DArray = (rows, cols, initialValue) => {
    const array = [];
    for (let row = 0; row < rows; row++) {
      const rowArray = [];
      for (let col = 0; col < cols; col++) {
        if (typeof initialValue === "function") {
          rowArray.push(initialValue(row, col));
        } else {
          rowArray.push(initialValue);
        }
      }
      array.push(rowArray);
    }
    return array;
  };
  ArrayUtils2.toShuffle = (data) => {
    const array = [...data];
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  };
  ArrayUtils2.popPick = (array) => {
    const index = Math.floor(Math.random() * array.length);
    return array.splice(index, 1)[0];
  };
  ArrayUtils2.chancePick = (array, config) => {
    const totalChance = array.reduce((sum, item) => sum + item.chance, 0);
    let randomValue = Math.random() * totalChance;
    for (const item of array) {
      if (randomValue < item.chance) {
        return item.data;
      }
      randomValue -= item.chance;
    }
    return pick(array.map((it) => it.data));
  };
  function pick(array, count) {
    if (array.length === 0 && count !== void 0) {
      return [];
    }
    if (count === void 0) {
      return array[Math.floor(Math.random() * array.length)];
    }
    const result = [];
    const usedIndices = /* @__PURE__ */ new Set();
    while (result.length < count && usedIndices.size < array.length) {
      const randomIndex = Math.floor(Math.random() * array.length);
      if (!usedIndices.has(randomIndex)) {
        result.push(array[randomIndex]);
        usedIndices.add(randomIndex);
      }
    }
    return result;
  }
  ArrayUtils2.pick = pick;
  function maxLength(array) {
    if (!array) {
      return { maxRows: 0, maxCols: 0, maxRowsCols: 0, total: 0 };
    }
    const maxRows = array.length;
    const maxCols = Math.max(...array.map((row) => row.length), 0);
    return {
      maxRows,
      maxCols,
      maxRowsCols: Math.max(maxCols, maxRows),
      total: array.reduce((total, row) => total + row.length, 0)
    };
  }
  ArrayUtils2.maxLength = maxLength;
  ArrayUtils2.toPush = (array = [], ...data) => {
    return [...array ?? [], ...data];
  };
  ArrayUtils2.toRemove = (array = [], ...data) => {
    return (array ?? []).filter((item) => !data.includes(item));
  };
  ArrayUtils2.toFilterOut = (array = [], predicate) => {
    return (array ?? []).filter((item) => !predicate(item));
  };
  ArrayUtils2.toFilter = (array = [], predicate) => {
    return (array ?? []).filter((item) => predicate(item));
  };
  ArrayUtils2.hasAll = (array = [], ...targetArray) => {
    return targetArray.every((item) => (array ?? []).includes(item));
  };
  ArrayUtils2.has = (array = [], ...targetArray) => {
    return targetArray.some((item) => (array ?? []).includes(item));
  };
  ArrayUtils2.hasNot = (array = [], ...targetArray) => {
    return targetArray.some((item) => !(array ?? []).includes(item));
  };
  ArrayUtils2.hasAllNot = (array = [], ...targetArray) => {
    return targetArray.every((item) => !(array ?? []).includes(item));
  };
  ArrayUtils2.relation = (...arrays) => {
    if (arrays.length === 0) {
      return {
        intersection: [],
        union: [],
        difference: [],
        symmetricDifference: []
      };
    }
    const sets = arrays.map((arr) => new Set(arr));
    const intersection = [...sets[0]].filter(
      (item) => sets.every((set) => set.has(item))
    );
    const union = [...new Set(arrays.flat())];
    const difference = [...sets[0]].filter(
      (item) => sets.slice(1).every((set) => !set.has(item))
    );
    const allUniqueElements = /* @__PURE__ */ new Set();
    for (let i = 0; i < sets.length; i++) {
      const currentSet = sets[i];
      const otherSetsUnion = new Set(
        arrays.filter((_, index) => index !== i).flat()
      );
      const uniqueToCurrent = [...currentSet].filter(
        (item) => !otherSetsUnion.has(item)
      );
      uniqueToCurrent.forEach((item) => allUniqueElements.add(item));
    }
    const symmetricDifference = [...allUniqueElements];
    return {
      intersection,
      union,
      difference,
      symmetricDifference
    };
  };
})(ArrayUtils || (ArrayUtils = {}));
export {
  ArrayUtils
};
//# sourceMappingURL=ArrayUtils.js.map
